import React from 'react';
import { gql } from '@apollo/client';
import { NumberField, Datagrid, SelectInput, FunctionField } from 'react-admin';
import List from 'components/List';
import LinkField from 'components/LinkField';
import ReviewLink from './ReviewLink';
import IdField from 'components/IdField';
import ProfessionalInput from 'components/ProfessionalInput';
import LocationInput from '../../components/LocationInput';
import CompanyInput from '../../components/CompanyInput';
import { IdFilter } from 'components/Filter';

const ReviewListFilters = [
  <IdFilter />,
  <ProfessionalInput alwaysOn source="search.professional_id" />,
  <CompanyInput alwaysOn source="search.company_id" />,
  <LocationInput alwaysOn source="search.location_id" />,
  <IdFilter label="Job ID" source="job_id" alwaysOn data-testid="job-input" />,
  <IdFilter alwaysOn label="Rating" source="rating" />,
  // reviews_for_type filter not currently working [FAC-5194]
  <SelectInput
    alwaysOn
    choices={[
      { id: 'reviews_for_professional', name: 'Reviews for Professional' },
      { id: 'reviews_for_company', name: 'Reviews for Company' },
    ]}
    source="search.reviews_for_type"
    label="Review Type"
  />,
];

const ReviewList = () => (
  <List filters={ReviewListFilters} exporter={false}>
    <Datagrid bulkActionButtons={false}>
      <IdField />
      <FunctionField
        label="Reviewer"
        render={({ reviewer_type, reviewer_id }) =>
          ReviewLink({ model: reviewer_type, id: reviewer_id })
        }
      />
      <LinkField label="Location ID" source="job.location.id" />
      <FunctionField
        label="Reviewee"
        render={({ reviewee_type, reviewee_id }) =>
          ReviewLink({ model: reviewee_type, id: reviewee_id })
        }
      />      <LinkField label="Job ID" source="job.id" />
      <NumberField label="Rating" source="rating" />
    </Datagrid>
  </List>
);

ReviewList.query = gql`
  query reviews($input: ReviewQueryInput) {
    _reviewsMeta(input: $input) {
      count
    }
    reviews(input: $input) {
      comments
      id
      job {
        id
        location {
          id
        }
      }
      rating
      reviewee_id
      reviewee_type
      reviewer_id
      reviewer_type
    }
  }
`;

export default ReviewList;
